import Conviction from '../lens/Conviction'
import LensBand from '../lens/LensBand'
import { LENSES } from '../../lib/lenses'
import type { Idea } from '../../services/qualyz'

/**
 * Attrappen-Zeilen fuer die unscharfe Vorschau hinter dem Login.
 *
 * Feste Muster statt echter Titel: Besucher bekommen die Ideen jenseits des
 * Ausschnitts gar nicht erst geliefert. Kuerzel und Namen sind nur Balken --
 * die Vorschau zeigt die Form der Liste und behauptet nichts ueber eine Aktie.
 */
const MUSTER: readonly string[][] = [
  ['BUY', 'STRONG', 'WATCH', 'BUY', 'PASS', 'BUY', 'WATCH'],
  ['STRONG', 'BUY', 'BUY', 'WATCH', 'BUY', '-', 'PASS'],
  ['BUY', 'WATCH', 'STRONG', 'PASS', 'BUY', 'WATCH', 'BUY'],
  ['WATCH', 'BUY', 'PASS', 'BUY', 'PASS', '-', 'STRONG'],
]

function attrappe(urteile: readonly string[]): Idea {
  const idee: Record<string, unknown> = {
    symbol: '',
    name: '',
    sector: null,
    market_cap: null,
    lenses_judged: 7,
    lenses_total: 7,
    lenses_selected: null,
    avg_score: 0,
  }
  let konviktion = 0
  LENSES.forEach((linse, i) => {
    const urteil = urteile[i]
    idee[linse.key] = 60
    idee[`${linse.key}_verdict`] = urteil === '-' ? 'PASS' : urteil
    idee[`${linse.key}_coverage`] = urteil === '-' ? 0 : 1
    if (urteil === 'BUY' || urteil === 'STRONG') konviktion += 1
  })
  idee.conviction = konviktion
  return idee as unknown as Idea
}

export default function UnscharfeIdeen({ anzahl = 4 }: { anzahl?: number }) {
  return (
    <>
      {Array.from({ length: anzahl }, (_, i) => {
        const idee = attrappe(MUSTER[i % MUSTER.length])
        return (
          <div key={i} className="q-list-row">
            <Conviction wert={idee.conviction} von={idee.lenses_total} />
            <div className="q-titlecell">
              <span className="q-skel q-skel--ruhig" style={{ width: 52, height: 13 }} />
              <span
                className="q-skel q-skel--ruhig"
                style={{ width: `${46 + ((i * 19) % 30)}%`, height: 9, marginTop: 5 }}
              />
            </div>
            <LensBand idea={idee} groesse="sm" />
            <span className="q-skel q-skel--ruhig" style={{ width: 34, height: 10 }} />
          </div>
        )
      })}
    </>
  )
}
